export const GET_LIST_NHANVAY = "GET_LIST_NHANVAY";
export const GET_LIST_NHANVAY_SUCCESS = "GET_LIST_NHANVAY_SUCCESS";
export const GET_LIST_NHANVAY_FAILURE = "GET_LIST_NHANVAY_FAILURE";

//Start
export const UPDATE_SEARCHDATA_NHANVAY = "UPDATE_SEARCHDATA_NHANVAY";
